import React, { useRef, useState } from "react";
import CaretDownBlue from "../../../assets/CaretDownBlue.svg";
import "./Accordion.scss";

const AccordionItem: React.FC<any> = ({ title, subtitle, children, isOpen, onClick }) => {
    const contentHeight: any = useRef();
    return (
        <div className="wrapper">
            <button
                className={`accordion-button ${isOpen ? "active" : ""} d-flex w-100`}
                onClick={onClick}
            >
                <div className="d-flex flex-column text-left accordion-header">
                    <div className="accordion-title">{title}</div>
                    <div className="accordion-subtitle">{subtitle}</div>
                </div>
                <div>
                    <img
                        className={`caret-icon ${isOpen ? '' : ''}`}
                        src={CaretDownBlue}
                        alt="CaretDown"
                    />
                </div>
            </button>

            <div
                ref={contentHeight}
                className="accordion-content-container"
                style={
                    isOpen
                        ? { display: 'flex' }
                        : { display: 'none' }
                }
            >
                <div className="accordion-content">{children}</div>
            </div>
        </div>
    );
};

const Accordion: React.FC<any> = ({ data }) => {
    const [activeIndex, setActiveIndex] = useState([0, 1, 2]);

    const handleItemClick = (index: number) => {
        setActiveIndex((prevIndex: any) => {
            
            if(!prevIndex.includes(index)){          //checking weather array contain the id
                prevIndex.push(index);               //adding to array because value doesnt exists
            }else{
                console.log('splice')
                prevIndex.splice(prevIndex.indexOf(index), 1);  //deleting
            }
            return [...prevIndex];
        });
    };
    return (
        <div className="accordion-container">
            {data.map((item: any, index: any) => (
                <AccordionItem
                    key={index}
                    title={item.title}
                    subtitle={item.subtitle}
                    isOpen={activeIndex.includes(index)}
                    children={item.children}
                    onClick={() => handleItemClick(index)}
                />
            ))}
        </div>
    );
}

export default Accordion;
